import React from "react";
import styles from './styles/LoginRegister.module.css';

/**
 * A text input no human sees or can tab to. Bots that fill in every field
 * they find put something here; the server treats a value as a bot signal.
 *
 * Hidden by moving it off-screen rather than with `display: none`, which
 * smarter form-fillers know to skip. "website" tempts bots but isn't a
 * field browsers or password managers autofill.
 */
function HoneypotField({ value, onChange }) {
    return (
        <div className={styles.honeypot} aria-hidden="true">
            <label>
                Leave this field empty
                <input
                    type="text"
                    name="website"
                    tabIndex={-1}
                    autoComplete="off"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
            </label>
        </div>
    );
}

export default HoneypotField;
